import { useTranslation } from "react-i18next";
import { TableCell, TableHead, TableRow } from "@material-ui/core";
import { ListHeaderTitle } from "components/List";

export default function ListHeader() {
  const { t } = useTranslation("mxheroShares");

  return (
    <TableHead>
      <TableRow style={{ height: "48px" }}>
        <TableCell />
        <TableCell>
          <ListHeaderTitle variant="button">
            {t("malware.list.threat")}
          </ListHeaderTitle>
        </TableCell>
        <TableCell>
          <ListHeaderTitle variant="button">
            {t("malware.list.detected")}
          </ListHeaderTitle>
        </TableCell>
        <TableCell>
          <ListHeaderTitle variant="button">
            {t("malware.list.status")}
          </ListHeaderTitle>
        </TableCell>
        <TableCell />
        <TableCell />
      </TableRow>
    </TableHead>
  );
}
